import { ComponentClassNames } from '../../util/classNames';
import { Depth, getDepthBoxShadow } from '../../util/styles/depth';
import { ZIndex } from '../../util/styles/zIndex';
import { ITheme, memoizeFunction, mergeStyleSets } from '../../util/styling';

import { defaultHeaderHeight as height } from './PageLayout.styles';

type HeaderClassNames = ComponentClassNames<'header'>;

export const getClassNames = memoizeFunction((suppressDropShadow: boolean, theme: ITheme): HeaderClassNames => {
  const boxShadow = suppressDropShadow ? undefined : getDepthBoxShadow(Depth.depth4);
  const backgroundColor = theme.isInverted
    ? theme.semanticColors.bodyBackground
    : theme.semanticColors.bodyStandoutBackground;

  return mergeStyleSets({
    header: {
      height,
      position: 'fixed',
      top: 0,
      right: 0,
      left: 0,
      zIndex: ZIndex.PageLayoutHeader,
      boxShadow,
      backgroundColor,
    },
  });
});
